import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import routes from "../../../routes";
import Loader from "../../layout/Loader";
import { commonConstants } from "../../../constants";
import { getMainUserToken, getUrlPermissions, getUserToken } from "../../../utils/user";
import { getUser } from "../../../selector/user";
import { commonActions, userActions } from "../../../actions";
import { setTimeZoneDiff } from "../../../helpers";

const Layout = ({
  defaultPath,
  defaultPreLoginPath,
  //topbarTheme,
  authToken,
  getMetaData,
  getBasicDetails,
  user,
}) => {
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (authToken) {
      getMetaData();
    }
    handleLoggedUser();
  }, [authToken]);

  /* useEffect(() => {
    handleLoggedUser();
  }, [user]); */

  useEffect(() => {
    document.title = `${window.location.pathname
      .charAt(1)
      .toUpperCase()}${window.location.pathname.slice(2)} | Smartotis`;
    setTimeZoneDiff();
  }, [window.location.pathname]);

  const handleLoggedUser = () => {
    if (!authToken) {
      navigate(defaultPreLoginPath);
    } else if (authToken && (!user || !user.email)) {
      getBasicDetails();
    } else if (user && user.email) {
      const urlPermissions = getUrlPermissions(window.location.pathname);
      const user_role = (user.role && parseInt(user.role)) || 0;

      if (!urlPermissions.includes(user_role)) {
        if (user_role === commonConstants.roles.pro) {
          navigate(defaultPath);
        } else if (
          [commonConstants.roles.client_admin, commonConstants.roles.client_user].includes(
            user_role
          )
        ) {
          const lastURL = localStorage.getItem("lastURL");
          if (lastURL) {
            localStorage.removeItem("lastURL");
            navigate(lastURL);
          } else if (user_role === commonConstants.roles.client_admin) {
            navigate(defaultPath);
          } else if (user_role === commonConstants.roles.client_admin) {
            navigate(defaultPath);
          }
        }
        return;
      }
    }
  };

  const openMenu = () => {
    setIsMenuOpened(!isMenuOpened);
  };

  const menu = routes.map((route, index) => {
    return route.component ? (
      <Route
        key={index}
        path={route.path}
        exact={route.exact}
        name={route.name}
        element={route.component}
      />
    ) : null;
  });

  return (
    <>
      <div id="layout-wrapper">
        <Header
          //theme={topbarTheme}
          isMenuOpened={isMenuOpened}
          //toggleRightSidebar={toggleRightSidebar}
          openLeftMenuCallBack={openMenu}
        />
        <div className="main-content">
          <div className="page-content mt-2">
            <div className="container-fluid">
              <Routes>
                {menu}
                {/* Redirect from any unmatched route to defaultPath */}
                <Route path="*" element={<Navigate to={defaultPath} />} />
              </Routes>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    defaultPath: state.globalData.defaultPath,
    defaultPreLoginPath: state.globalData.defaultPreLoginPath,
    //topbarTheme: state.Layout.topbarTheme,
    authToken: getUserToken(),
    user: getUser(state),
  };
};

const mapDispatchToProps = {
  getMetaData: commonActions.getMetaData,
  getBasicDetails: userActions.getBasicDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
